
import React, { Component } from "react";
import { connect } from "react-redux";
import { sendAgrementPDPA } from "../../actions";
import IntlMessages from "../../utils/IntlMessages";
import {
  reduxForm,
  Field ,
} from "redux-form";
import renderInputCheckbox from '../../utils/CustomField/renderInputCheckbox'
import Policy_en from "../policy_en";
import Policy_th from "../policy_th";
import {
  FormGroup,
  Col,
} from 'reactstrap';

class PopupPDPA extends Component {

  
  constructor(props) {
    super(props);
    this.state={
      pdpa : JSON.parse(localStorage.getItem("pdpa-agement")),
      term : localStorage.getItem("term-agement"),
      sendAgrement : false,
      display: false,
    }
  }

  componentDidMount(){
    if((this.state.pdpa && this.state.pdpa.id)){
      this.props.sendAgrementPDPA({id:this.state.pdpa.id,agreement:this.state.pdpa.action});
    }
  }


  componentWillReceiveProps(nextProps){
    if(nextProps.display === true && this.state.display!==true){
      this.setState({
        display: true
      })
    }
  }

  render() { 
    const { locale, formValues, handleSubmit } = this.props;

    if(((this.state.pdpa && this.state.pdpa.id) || this.state.sendAgrement===true || !this.state.term) && !this.state.display){
      return <></>;
    }
     return (
      <div
        className="modal fade show"
        role="dialog"
        tabIndex="-1"
        style={{ display: "block" }}
      >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content white">
          <form onSubmit = {  
            handleSubmit( async () => {
              await this.props.sendAgrementPDPA(formValues);
              this.setState({
                sendAgrement:true,
                display: false
              })
              if(this.props.closeModal){
                this.props.closeModal();
              }
            })
          }>
            <div className="modal-header" >
            <IntlMessages id="pdpa.header"></IntlMessages>
            
            </div>
            <div className="modal-body text-left">
            <section id="divR"  onScroll={this.onScroll} ref={input => {this.refs = input;}} style={{ overflowY: "scroll" , overflowX:"hidden", maxHeight : "400px"}}>
              {
                locale === "en" ? <Policy_en />  :  <Policy_th />
              }
                <div>
                <label htmlFor="agreement"></label>
                <div>
                  <FormGroup row>
                    <Col md="6">
                        <label>
                          <Field
                            name="agreement"
                            component="input"
                            type="radio"
                            value="accept"
                          />{' '}
                          <IntlMessages id="pdpa.agree"></IntlMessages>
                        </label>
                    </Col>
                    <Col md="6">
                        <label>
                          <Field
                            name="agreement"
                            component="input"
                            type="radio"
                            value="decline"
                          />{' '}
                          <IntlMessages id="pdpa.reject"></IntlMessages>
                        </label>
                    </Col>
                  </FormGroup>
                  </div>
                </div>
                    <button
                      type="submit"
                      className={"btn btn-wrs mb-3"}
                    >
                      <IntlMessages id="pdpa.send"></IntlMessages>
                    </button>
            </section>
 
            </div>
            <div className="modal-foot container text-center">
                 
            </div>
          </form>
        </div>
      </div>
    </div>
    );
  }
}

function validate(values) {
  const errors = {}; 
  if(!values){
    errors.defaullt = 'Required'}
  else  if(!values.agrement){
    errors.agrement = 'Required'}

    return errors
    
}

const mapStateToProps = ({ form ,setting }) => {
  const {
    locale: { locale },
  } = setting; 
  const formValues = form.FormPopupPDPA ? form.FormPopupPDPA.values : '';
  return { locale , formValues  };
};

PopupPDPA = reduxForm({ validate,  form: "FormPopupPDPA"})(PopupPDPA);

export default connect(mapStateToProps, {
  sendAgrementPDPA
})(PopupPDPA);
